import styled from 'styled-components';
import WhatsappIcon from '../../../../../new-components/svg-icons/WhatsappIcon';
import ButtonTextIcon from '../../../../../new-components/ui/ButtonTextIcon';
import { useSelector } from 'react-redux';
import { handleCardContactEvent } from '../../../../../helpers/cards';
import { trackEvent } from '../../../../../new-lib/remarketing';
import { useRouter } from 'next/router';
import { CTATypes, EntityTypes } from '../../../../../new-lib/constants/common';
import { useTranslation } from 'next-i18next';
import WhatsappCityScapeOffers from '../../../../../helpers/whatsapp/whatsapp-cityscape-offer';
import { EntityOffer } from '../../../../../new-lib/types/entity';

type WhatsappButtonProps = {
  entity: any;
  offer: EntityOffer;
};

const WhatsappButton = ({ entity, offer }: WhatsappButtonProps) => {
  const referer = useSelector((state: any) => state.app.referer);
  const userId = useSelector((state: any) => state.app.userId);
  const eventId = useSelector((state: any) => state.app.eventId);
  let { asPath } = useRouter();
  const { t } = useTranslation('common');

  const isMobile = useSelector((state: any) => state.app.isMobile);

  const whatsapp = new WhatsappCityScapeOffers(
    offer.compound,
    asPath,
    referer,
    userId,
    eventId,
    CTATypes.CITYSCAPE_COMPOUND,
    offer
  );

  const clickEventData: any = {
    entity: entity,
    recommended: false
  };

  const handleWhatsAppClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    whatsapp.launchWhatsApp();
    handleCardContactEvent({
      ...clickEventData,
      eventAction: 'whatsapp',
      eventId: eventId,
      compound: entity,
      entityType: EntityTypes.COMPOUND
    });
    trackEvent.purchase({
      listingIds: [entity.id],
      listingPrice: entity.min_price
    });
  };

  return (
    <WhatsappButtonContainer>
      {isMobile ? (
        <ButtonTextIcon
          text={t('whatsapp')}
          icon={<WhatsappIcon />}
          backgroundColor="white"
          color="#4CD964"
          fontSize="14px"
          padding="0px, 8px, 0px, 8px"
          border="1px solid #4CD964"
          containerClass="whatsapp-btn"
          onClick={(event: any) => handleWhatsAppClick(event)}
        />
      ) : (
        <ButtonTextIcon
          backgroundColor="white"
          color="#4CD964"
          icon={<WhatsappIcon />}
          text={t('whatsapp')}
          onClick={(event: any) => handleWhatsAppClick(event)}
          fontSize="16px"
          padding="0 16px 0 16px"
          border="1px solid #4CD964"
        />
      )}
    </WhatsappButtonContainer>
  );
};

const WhatsappButtonContainer = styled.div`
  button {
    width: 167px;
    height: 45px;
  }

  .whatsapp-btn {
    button {
      width: 100%;
      height: 45px;
    }
  }
`;

export default WhatsappButton;
